import * as M from "../../../data/maybe";
import * as Fold from "../fold";
import * as Setter from "../setter";
export * from "./compose";
export * from "./extra/equality";
export const traversal = (fold, setter) => (Object.assign(Object.assign({}, fold), setter));
export const over = (g, t) => traversal(t, Setter.over(g, t));
export function _filtered(p) {
    return traversal(Fold.fold((fold, empty, s) => (p(s) ? fold(s, empty) : empty)), Setter.setter((g) => (s) => (p(s) ? g(s) : s), (a) => (s) => (p(s) ? a : s)));
}
export function _filteredOn(f, p) {
    return traversal(Fold.fold((fold, empty, s) => M.foldMapConst(p, false, Fold.preview(f, s)) ? fold(s, empty) : empty), Setter.setter((g) => (s) => (M.foldMapConst(p, false, Fold.preview(f, s)) ? g(s) : s), (a) => (s) => (M.foldMapConst(p, false, Fold.preview(f, s)) ? a : s)));
}

